(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["btn-scroll-top"] && !Shopify.designMode) return;
  try {
    var CTA_SELECTORS = '.product-form__submit, .custom-bundle-btn, .nw-new-bundle-cta-button, .labor-cta__button';
  // trust-block.liquid can duplicate .custom-bundle-btn earlier in the column; skip it.
  var DUPLICATE_CTA_ANCESTOR = '.main-image-bottom-reviews-parent-checkout-button';

  function findCta(container) {
    var matches = Array.from(container.querySelectorAll(CTA_SELECTORS)).filter(function (el) {
      return !el.closest(DUPLICATE_CTA_ANCESTOR);
    });
    return matches.pop();
  }

  function initBtnScrollTop(bar) {
    var container = document.getElementById(bar.getAttribute('data-target'));
    var button = bar.querySelector('.btn-scroll-top__button');
    if (!container || !button) return;

    var target = findCta(container) || container;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    button.addEventListener('click', function () {
      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: target === container ? 'start' : 'center',
      });
    });

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('btn-scroll-top--visible', scrolledPast);
        bar.inert = !scrolledPast;
      });
    }).observe(target);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-btn-scroll-top]').forEach(initBtnScrollTop);
  });
  } catch(e) { console.error(e); }
})();

})();
